"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.native.help': 'El conocimiento nativo está oculto para usuarios regulares pero disponible para asistentes de IA',
};
